import { render, staticRenderFns } from "./registerAgreement.vue?vue&type=template&id=6daccb79&scoped=true&"
import script from "./registerAgreement.vue?vue&type=script&lang=js&"
export * from "./registerAgreement.vue?vue&type=script&lang=js&"
import style0 from "./registerAgreement.vue?vue&type=style&index=0&id=6daccb79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daccb79",
  null
  
)

export default component.exports